import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { Grid } from "@mui/material"

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { BACKEND_APIS } from "@constants"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { AppAcrissAutocomplete, AppCategoriesAutocomplete } from "@components"
import { batch } from "@preact/signals-react"


export default function AlertsComparisonType({ url = "comparison_type" }) {

	const {
		dataInfo: comparisonType,
		setDataInfo: setComparisonType
	} = useAlertsDataInfo(alertsDrawerData.peek().comparisonType)

	const {
		dataInfo: acriss,
		setDataInfo: setAcriss
	} = useAlertsDataInfo(alertsDrawerData.peek().acriss || null)

	const {
		dataInfo: category,
		setDataInfo: setCategory
	} = useAlertsDataInfo(alertsDrawerData.peek().category || null)

	return <Grid container sx={{ display: "flex", justifyContent: "space-between" }} spacing={3}>
		<Grid item xs={6}>
			<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
				disableClearable
				label="Comparison type"
				placeholder="Comparison type"
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/${url}`}
				value={comparisonType.value}
				onChange={e => batch(() => {
					setComparisonType(e.target.value, 'comparisonType')
					setAcriss([], 'acriss')
					setCategory([], 'category')
				})}
			/>
		</Grid>
		{(comparisonType.value === 1 || comparisonType.value === 2) && <Grid item xs={6}>
			<AppAcrissAutocomplete
				value={acriss.value}
				onChange={e => setAcriss(e.target.value, 'acriss')}
			/>
		</Grid>}
		{(comparisonType.value === 0 || comparisonType.value === 2) && <Grid item xs={6}>
			<AppCategoriesAutocomplete
				value={category.value}
				onChange={e => setCategory(e.target.value, 'category')}
			/>
		</Grid>}
	</Grid>
}